import type { JSX } from 'react';
import React, { Suspense } from 'react';
import { BaseSpin } from '@components/spin';
type ReturnType<T> = (props: T) => JSX.Element;

export const withLoading = <T extends object>(Component: React.ComponentType<T>): ReturnType<T> => {
    return (props: T) => (
        <Suspense fallback={<BaseSpin size="large" fullscreen description="Loading..." />}>
            <Component {...props} />
        </Suspense>
    );
};
